var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.25C2.41421 3.25 2.75 3.58579 2.75 4V13.6C2.75 14.7325 2.75058 15.5367 2.80201 16.1661C2.85271 16.7867 2.94909 17.171 3.10423 17.4755C3.41582 18.087 3.913 18.5842 4.52453 18.8958C4.829 19.0509 5.21325 19.1473 5.83388 19.198C6.46326 19.2494 7.26752 19.25 8.4 19.25H22C22.4142 19.25 22.75 19.5858 22.75 20C22.75 20.4142 22.4142 20.75 22 20.75H8.36698C7.27484 20.75 6.40935 20.75 5.71173 20.693C4.99834 20.6347 4.39472 20.5131 3.84355 20.2323C2.94978 19.7769 2.22312 19.0502 1.76772 18.1565C1.48688 17.6053 1.36527 17.0017 1.30699 16.2883C1.24999 15.5906 1.24999 14.7251 1.25 13.633L1.25 4C1.25 3.58579 1.58579 3.25 2 3.25ZM16.25 6C16.25 5.58579 16.5858 5.25 17 5.25H21.5C22.1904 5.25 22.75 5.80964 22.75 6.5V11C22.75 11.4142 22.4142 11.75 22 11.75C21.5858 11.75 21.25 11.4142 21.25 11V7.81066L15.8839 13.1768C15.3957 13.6649 14.6043 13.6649 14.1161 13.1768L11 10.0607L6.53033 14.5303C6.23744 14.8232 5.76256 14.8232 5.46967 14.5303C5.17678 14.2374 5.17678 13.7626 5.46967 13.4697L10.1161 8.82322C10.6043 8.33507 11.3957 8.33507 11.8839 8.82322L15 11.9393L20.1893 6.75H17C16.5858 6.75 16.25 6.41421 16.25 6ZM11.1768 9.88388C11.1767 9.88398 11.1769 9.88379 11.1768 9.88388V9.88388Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResult);
export default __webpack_public_path__ + "static/media/Result.d3d51f9227c371c15009e734c1efdfb3.svg";
export { ForwardRef as ReactComponent };